import React, { Component } from 'react';  // import the React library
import Gallery from '../articleComponents/imageGallery';
import Connect from '../articleComponents/connect';
import { FaLinkedin } from 'react-icons/fa';
import { NavLink } from 'react-router-dom'; 
import Routes from '../routes';
import ArticleList from './articleList';
import { motion } from 'framer-motion';
import SocialMedia from '../articleComponents/SocialMedia';
import planet from '../pictures/planet_img.jpg';
import MetaTags from './MetaTags';


 class Home extends React.Component {
constructor(props){
  super(props)

  this.state = {
message: "Click here to see the Highway 60 posts",
articles: ""
  }
}

ArticleList = () => {
  this.setState({
    message: "",
 articles: <ArticleList />
  })
}

  render () {
     return(

<motion.div id="body" 
initial={{ opacity: 0 }}
animate={{opacity: 1 }}
exit={{ opacity: 0}}
transition={{duration: 1}}
>


<MetaTags title="Highway 60 Home Page" desc="Highway 60 is about coding, marketing, writing, high tech, and the people who make up the most beautiful stretch of Land on G-d's green earth." 
URL="https://highway-60.web.app/" imageURL={planet} />

      <div id="thumbsUp" class="fa fa-road" style={{fontSize: '8em', marginTop: '12px', color: 'charcoal'}}>
    
      </div>
       
    <motion.h1 style={{fontFamily: 'Yesteryear', fontSize: '3em'}}
    initial={{ color: "black" }}
    animate={{ color: "blue" }}
    exit={{ color: "green" }}
    transition={{ duration: 2 }}
    >Highway 60</motion.h1>
          <h2 style={{fontFamily: 'Gentium Book Basic', fontSize: '2em', lineHeight: 1.5}}><ul>
        <li>Chronicling my journey from marketing to development.</li> 
        <li>Tiptoeing the tightrope of writing and coding. </li>
        <li>Making new friends along the highway to heaven.</li>
        </ul></h2>
<SocialMedia url="https://highway-60.firebaseapp.com/" title="Highway 60" hashtag="#marketing" hashtagArray={["marketing", "writing"]} via="TheHighway60" desc="This is the home page for Highway 60." />
        <br />
        
        <div onClick={this.ArticleList}>
        <h1 style={{fontSize: "3em", textDecoration: "underline"}}>{this.state.message}</h1>      
        {this.state.articles}
          </div>

        <br />
           <Connect />
           <script src="https://platform.linkedin.com/in.js" type="text/javascript">lang: en_US</script>
<script type="IN/Share" data-url="https://www.linkedin.com"></script>

    </motion.div>

    );  
   }
   }

    export default Home;
